export const TOAST_TYPES = {
	INFO: 'info',
	SUCCESS: 'success',
	WARNING: 'warning',
	ERROR: 'error',
	SECURITY: 'security',
	NEUTRAL: 'neutral',
	LOADING: 'loading',
	DELETED: 'deleted',
	COPIED: 'copied',
	SENT: 'sent',
	LOCKED: 'locked',
	OFFLINE: 'offline',
	ONLINE: 'online',
	CANCELLED: 'cancelled',
	DEACTIVATED: 'deactivated',
	ASSIGNED: 'assigned',
	PERMISSION: 'permission',
	TOPUP: 'topup',
	CARD: 'card',
};
